export const theme = {
  colors: {
    // Primary purple palette (Xintra inspired)
    primary: '#5c67f7',
    primaryHover: '#4c56e6',
    primaryActive: '#3c46d5',
    primaryLight: '#e8e9ff',
    primaryLighter: '#f4f5ff',

    antdPrimary: '#1890FF',

    success: '#10b981', // Green
    warning: '#f59e0b', // Amber
    error: '#ef4444', // Red
    info: '#1890ff',

    // // Purple variations
    purple: {
      50: '#f4f5ff',
      100: '#e8e9ff',
      200: '#d1d4ff',
      300: '#a8aefc',
      400: '#7c85f8',
      500: '#5c67f7', // Main primary
      600: '#4c56e6',
      700: '#3c46d5',
      800: '#2d36c4',
      900: '#1e26b3',
    },

    // Neutral colors
    white: '#ffffff',
    black: '#000000',
    gray: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },

    // Background colors
    background: '#f8fafc',
    surface: '#ffffff',
    sidebar: '#202947', // Dark purple sidebar
    sidebarHover: 'rgba(255, 255, 255, 0.05)',
    sidebarBorder: 'rgba(255, 255, 255, 0.1)',

    // Text colors
    textPrimary: '#1e293b',
    textSecondary: '#64748b',
    textDisabled: '#94a3b8',

    // Border colors - darker for better visibility
    border: '#cbd5e1',
    borderLight: '#e2e8f0',

    // Card and surface colors
    cardBackground: '#ffffff',
    cardHover: '#f8fafc',

    // Status colors
    successLight: '#d1fae5',
    warningLight: '#fef3c7',
    errorLight: '#fee2e2',
    infoLight: '#e8e9ff',

    // Custom Xintra colors for tags and components
    tagColors: {
      purple: '#5c67f7',
      magenta: '#eb2f96',
      geekblue: '#2f54eb',
      cyan: '#13c2c2',
      blue: '#1890ff',
      volcano: '#fa541c',
      orange: '#fa8c16',
      gold: '#faad14',
      green: '#52c41a',
    },
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Standardized spacing for consistent UI
    standard: '16px', // Primary spacing for most components
    compact: '12px', // For tighter layouts
    relaxed: '24px', // For more spacious layouts
  },

  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },

  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },

  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: "'SF Mono', ui-monospace, Menlo, Consolas, monospace",
    fontSize: {
      xxs: '8px',
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '28px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  breakpoints: {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px',
  },
};

export type Theme = typeof theme;
